// /formapagamento/empresa/{idEmpresa}/pagamentos-desativados
import axios from 'axios'
import { RECUPERAR_FORMA_PAGAMENTO_DESATIVADOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function recuperarFormaPagamentosDesativados (idEmpresa) {
  const url = `${URL}/formapagamento/empresa/${idEmpresa}/pagamentos-desativados`;
  return dispatch => axios.get(url,SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: RECUPERAR_FORMA_PAGAMENTO_DESATIVADOS,
        payload: response
      })
  );
}